import { AUTH_USER, AUTH_ERROR, DEAUTH, SIGNUP, SIGNUP_ERR, CHANGE_PASSWORD, CHANGE_PASSWORD_ERR, REQUEST_FORGOT_PASSWORD, REQUEST_FORGOT_PASSWORD_ERR, UPDATE_FORGOT_PASSWORD, UPDATE_FORGOT_PASSWORD_ERR, INITIATE_SIGNIN, REGISTER_DEVICE, SHOW_PDPA_POPUP, HIDE_PDPA_POPUP, PDPA_CONSENT_SUCCESS, PDPA_CONSENT_ERROR } from '../actions/auth/type';

const initState = { secret: null, components: null, authenticated: false, error: "", user_id: -1, signupResult: null, signupErr: null, changePasswordResult: null, changePasswordErr: null, reqForgotPassword: null, reqForgotPasswordErr: null, updateForgotPassword: null, updateForgotPasswordErr: null, initSignin: null, showPDPAPopup: false, pdpaConsentResult: null, pdpaConsentError: null };
export default function (state = initState, action) {
    switch (action.type) {
        case AUTH_USER:
            const profile = action.payload.profile;
            const user_id = profile ? profile.user_id : -1;
            return { ...state, authenticated: user_id !== -1, user_id: user_id, error: "" };
        case AUTH_ERROR:
            return { ...state, authenticated: false, user_id: -1, error: action.payload };
        case DEAUTH:
            return { ...state, authenticated: false, user_id: -1 };
        case SIGNUP:
            return { ...state, signupResult: action.payload };
        case SIGNUP_ERR:
            return { ...state, signupErr: action.payload };
        case CHANGE_PASSWORD:
            return { ...state, changePasswordResult: action.payload };
        case CHANGE_PASSWORD_ERR:
            return { ...state, changePasswordErr: action.payload, changePasswordResult: false };
        case REQUEST_FORGOT_PASSWORD:
            return { ...state, reqForgotPassword: action.payload };
        case REQUEST_FORGOT_PASSWORD_ERR:
            return { ...state, reqForgotPasswordErr: action.payload, reqForgotPassword: false };
        case UPDATE_FORGOT_PASSWORD:
            return { ...state, updateForgotPassword: action.payload };
        case UPDATE_FORGOT_PASSWORD_ERR:
            return { ...state, updateForgotPasswordErr: action.payload, updateForgotPassword: false };
        case INITIATE_SIGNIN:
            return { ...state, initSignin: action.payload };
        case REGISTER_DEVICE:
            return { ...state, secret: action.payload.secret, components: action.payload.components };
        case SHOW_PDPA_POPUP:
            return { ...state, showPDPAPopup: action.payload };
        case HIDE_PDPA_POPUP:
            return { ...state, showPDPAPopup: action.payload };
        case PDPA_CONSENT_SUCCESS:
            return { ...state, pdpaConsentResult: action.payload, pdpaConsentError: null };
        case PDPA_CONSENT_ERROR:
            return { ...state, pdpaConsentError: action.payload, pdpaConsentResult: false };
        default:
            return { ...state };
    }
}